import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Trophy } from "lucide-react";
import LookupScreen from "../user/lookup";
// import { useUserContext } from "../../context/userContext";
import m from "../../assets/m.svg";
import topPicks from "../../assets/top-picks.svg";
import profile from "../../assets/profile.svg";
import referrals from "../../assets/r.png";


const BottomNavbar = () => {
  const [isLookupOpen, setLookupOpen] = useState(false);
  // const { user } = useUserContext();

  return (
    <>
      <div className="fixed bottom-0 left-0 w-full bg-white shadow-lg border-t border-gray-200 flex justify-around items-center py-2 z-50">
        <NavItem to="/account/home" icon={m} label="Matches" />
        
        {/* {user?.user?.plan !== "free" && (
          <button
            onClick={() => setLookupOpen(true)}
            className="flex flex-col items-center justify-center gap-1 px-4 py-2 sm:hidden"
          >
            <img src="/src/assets/lookup.svg" alt="Lookup" className="w-6 h-6" />
            <span className={`text-sm font-medium ${isLookupOpen ? "text-custom-green" : "text-gray-500"}`}>
              Lookup
            </span>
          </button>
        )} */}
        
        <NavItem to="/account/top-picks" icon={topPicks} label="Top Picks" />

        <NavItem 
          to="/account/predictwin" 
          lucideIcon={Trophy} 
          label="Predict & Win" 
        />

        {/* {user?.user?.plan !== "Free" && (
          <NavItem to="/account/referrals" icon={referrals} label="Referrals" />
        )} */}
        <NavItem to="/account/referrals" icon={referrals} label="Referrals" />

        <NavItem to="/account/profile" icon={profile} label="Profile" />
      </div>

      {/* Lookup screen modal */}
      {isLookupOpen && <LookupScreen isOpen={isLookupOpen} onClose={() => setLookupOpen(false)} />}
    </>
  );
};

const NavItem = ({ to, icon, lucideIcon: LucideIcon, label, className }) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      className={`flex flex-col items-center justify-center gap-0.5 min-w-0 flex-1 py-1 ${className}`}
    >
      {LucideIcon ? (
        <LucideIcon 
          className={`w-5 h-5 flex-shrink-0 ${isActive ? "text-custom-green" : "text-gray-500"}`}
        />
      ) : (
        <img
          src={icon}
          alt={label}
          className={`w-5 h-5 flex-shrink-0 ${isActive ? "active-icon" : ""}`}
        />
      )}
      <span className={`text-[11px] font-medium text-center leading-tight ${isActive ? "text-custom-green" : "text-gray-500"}`}>
        {label}
      </span>
    </Link>
  );
};

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.string,
  lucideIcon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

NavItem.defaultProps = {
  icon: null,
  lucideIcon: null,
  className: "",
};

export default BottomNavbar;